(function () {
  var HEART_PATH =
    'M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z';

  function getContainers() {
    return document.querySelectorAll('.product-block--wishlist-pdp #swym-atw-button-container');
  }

  function getConfig() {
    return window.swymATWButtonConfig || {};
  }

  function getProductId() {
    if (window.SwymProductInfo && window.SwymProductInfo.product && window.SwymProductInfo.product.id) {
      return String(window.SwymProductInfo.product.id);
    }
    var block = document.querySelector('.product-block--wishlist-pdp');
    if (block && block.dataset.productId) return block.dataset.productId;
    return null;
  }

  function formatLabel(base, count) {
    var label = (base || 'Add to Wishlist').trim().toUpperCase();
    if (count != null && !isNaN(count) && count > 0) return label + ' (' + count + ')';
    return label;
  }

  function ensureIcon(svg) {
    if (!svg || svg.querySelector('path')) return;
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', HEART_PATH);
    svg.appendChild(path);
  }

  function enhance(container, socialCount) {
    if (!container) return;

    container.classList.add('consent-given');

    var button = container.querySelector('#swym-atw-pdp-button, .atw-button');
    if (!button) return;

    var svg = container.querySelector('#swym-atw-pdp-button-icon, .atw-button-icon');
    var textEl = container.querySelector('#swym-atw-pdp-button-text, .atw-button-text');
    var cfg = getConfig();
    var isAdded =
      button.classList.contains('atw-button-added') || button.classList.contains('atw-button-added-color');
    var base = isAdded ? cfg.AddedToWishlistButtonText : cfg.AddToWishlistButtonText;
    var label = formatLabel(base, socialCount);

    ensureIcon(svg);

    if (textEl) {
      textEl.textContent = label;
      textEl.setAttribute('aria-hidden', 'false');
    }

    button.setAttribute('aria-label', label);
    button.classList.remove('atw-button-loading');
  }

  function enhanceAll(socialCount) {
    getContainers().forEach(function (container) {
      enhance(container, socialCount);
    });
  }

  function fetchSocialCount(callback) {
    var empi = getProductId();
    var swat = window._swat;

    if (empi && window.SwymViewProducts && window.SwymViewProducts[empi]) {
      var entry = window.SwymViewProducts[empi];
      if (entry.socialCount != null && entry.socialCount >= 0) {
        callback(parseInt(entry.socialCount, 10));
        return;
      }
    }

    if (empi && swat && swat.wishlist && typeof swat.wishlist.getSocialCount === 'function') {
      swat.wishlist.getSocialCount(
        { empi: empi },
        function (res) {
          var count = res && res.data && res.data.count != null ? parseInt(res.data.count, 10) : null;
          callback(count);
        },
        function () {
          callback(null);
        }
      );
      return;
    }

    callback(null);
  }

  function refresh() {
    fetchSocialCount(function (count) {
      enhanceAll(count);
    });
  }

  function onSwymReady(swat) {
    refresh();
    if (!swat || !swat.evtLayer) return;
    swat.evtLayer.addEventListener('sw:addedtowishlist', function () {
      window.setTimeout(refresh, 400);
    });
    swat.evtLayer.addEventListener('sw:removedfromwishlist', function () {
      window.setTimeout(refresh, 400);
    });
  }

  enhanceAll(null);
  refresh();

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymReady);

  if (window._swat) onSwymReady(window._swat);

  window.setTimeout(refresh, 800);
  window.setTimeout(refresh, 2500);
})();
